(() => {
  const params = new URLSearchParams(window.location.search);
  const requestedWindow = params.get('window');
  if (!requestedWindow) return;

  // From "Will it fit my car?": fill in the car the customer typed, if the field is still empty.
  const vehicle = (params.get('vehicle') || '').trim().slice(0, 45);
  const fillVehicle = () => {
    if (!vehicle) return;
    const field = document.querySelector('[name="properties[Vehicle year, make, and model]"]');
    if (field && !field.value) {
      field.value = vehicle;
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
  };
  fillVehicle();
  window.setTimeout(fillVehicle, 1200);

  const values = {
    'rear-side': 'Rear Side Door Window',
    'back-windshield': 'Back Windshield',
    'front-windshield': 'Front Windshield',
  };

  const expected = values[requestedWindow];
  if (!expected) return;

  const selectWindow = () => {
    const controls = document.querySelectorAll(
      'variant-picker [data-option-name="Select Window"], variant-picker select[name*="Select Window"]'
    );

    for (const control of controls) {
      if (control.matches('input[type="radio"]') && control.value === expected) {
        if (!control.checked) control.click();
        control.closest('fieldset')?.scrollIntoView({ block: 'center' });
        return true;
      }

      if (control.matches('select')) {
        const option = Array.from(control.options).find((item) => item.value === expected);
        if (!option) continue;
        control.value = expected;
        control.dispatchEvent(new Event('change', { bubbles: true }));
        control.scrollIntoView({ block: 'center' });
        return true;
      }
    }

    return false;
  };

  if (selectWindow()) return;

  const observer = new MutationObserver(() => {
    if (!selectWindow()) return;
    observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 8000);
})();
